<template>
  <form>
    <div class="settings-top-bar sticky-header">
      <div class="top-bar">
        <p>
          <a class="btn btn-orange btn-icon back" :title="$t('general.back')" @click.prevent="backButton">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
        </p>
        <p class="d-inline-flex">
          <a class="btn btn-danger btn-icon btn btn mar-rt-10 delete" v-if="id" @click.prevent="handleDelete">
            <img src="/static/img/icons/icon-close.png">
            {{$t('general.delete')}}
          </a>
          <button type="submit" class="btn btn-success btn-icon mar-rt-10 save"  @click.prevent="validate" :title="$t('general.save') + ' ' + $t('settingUsers.single')">
            <img src="/static/img/icons/save.png">
            {{$t('general.save')}}
          </button>
        </p>
      </div>
    </div>

    <div class="row mar-to-15 mar-bt-15" style="display: flex; justify-content: flex-start; align-items: stretch;">
      <div class="col-lg-12 col-md-12">
        <div class="card" style="height:100%; width:100%; margin: 0;">
          <div :class="(loading ? 'show-loader' : 'hide-loader')">
            <div class="el-loading-spinner">
              <svg viewBox="25 25 50 50" class="circular">
                <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
              </svg>
            </div>
          </div>
          <div class="card-content">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>ID</label>
                  <input type="number"
                    disabled
                    placeholder="ID"
                    v-model="model.id"
                    class="form-control">
                </div>
                <div class="form-group">
                  <label>{{$t('kds.name')}}</label>
                  <input type="text"
                    name="name"
                    data-vv-as="name"
                    :placeholder="$t('kds.name')"
                    v-validate="modelValidations.name"
                    v-model="model.name"
                    class="form-control">
                  <small class="text-danger" v-if="errors.has('name')">
                    {{ getError('name') }}
                  </small>
                </div>
                <div class="form-group mar-to-15 label-input">
                  <label>Offline</label>
                  <p-switch v-model="model.is_offline" @input="limitToOne" type="success" ></p-switch>
                </div>
                <div class="form-group">
                  <label>{{$t('kds.location')}}</label>
                  <v-select
                    v-model="model.locations"
                    multiple
                    @input="limitToOne"
                    :options="locations"
                    value="id"
                    label="name"
                    :placeholder="model.locations ? $t('kds.location') : 'All'">
                  </v-select>
                </div>
                <div class="form-group">
                  <label>{{$t('kds.section')}}</label>
                  <el-select
                    v-model="model.sections"
                    multiple
                    collapse-tags
                    value-key="id"
                    style="width: 100%; height: auto; min-height: 40px;"
                    :placeholder="model.sections && model.sections.length ? $t('kds.section') : 'All'">
                    <el-option
                      v-for="section in sectionOptions"
                      :key="section.id"
                      :label="section.name"
                      :value="section">
                    </el-option>
                  </el-select>
                </div>
                <div class="form-group" v-if="model.id">
                  <label>{{$t('settingTable.loginCode')}}</label>
                  <input
                    type="text"
                    name="token"
                    disabled="true"
                    :placeholder="$t('settingTable.loginCode')"
                    :value="model.company_id + '.' + model.id"
                    class="form-control">
                </div>
                <div class="form-group" v-if="!model.is_offline">
                  <label>URL</label>
                  <input type="text"
                    disabled
                    placeholder="Url"
                    v-model="model.url"
                    class="form-control">
                </div>
                <div class="form-group" v-if="model.is_offline">
                  <label>IP Server</label>
                  <input type="text"
                    placeholder="Ip"
                    v-model="model.server_ip"
                    class="form-control">
                </div>
                <div class="form-group mar-to-15 label-input">
                  <label>{{$t('settingTable.yumm_integration_external_ip')}}</label>
                  <input
                    type="text"
                    v-model="model.yumm_integration_external_ip"
                    class="form-control"
                    style="max-width: 280px;"
                    placeholder="Ip">
                </div>
              </div>
            </div>
            <!-- <p class="text-danger" v-if="errors.has('error')">
              {{ getError('error') }}
            </p> -->
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
  import Vue from 'vue'
  // import {mapFields} from 'vee-validate'
  import {Input, Upload, Button, DatePicker} from 'element-ui'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'

  Vue.use(DatePicker)
  Vue.use(Upload)
  Vue.use(Button)
  Vue.use(Input)

  export default {
    components: {
      PSwitch,
      [Button.name]: Button,
      [Input.name]: Input
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    created () {
      this.loading = true
      this.locations = this.$session.get('selectedCompanyData').locations_details
      this.getSections()
      if (this.route.params.id) {
        this.getData()
      }
    },
    data () {
      return {
        id: this.route.params.id || null,
        model: {
          name: null,
          is_offline: false,
          server_ip: null,
          yumm_integration_external_ip: '',
          sections: []
        },
        modelValidations: {
          name: {
            required: true,
            min: 3
          },
          color: {
            required: true
          }
        },
        isNew: true,
        loading: true,
        locations: [],
        sectionOptions: []
      }
    },
    methods: {
      getData () {
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/kds/' + this.id, 'GET', data, (response) => {
          if (response.status) {
            let data = response.data
            if (!data.sections || !data.sections.length) {
              data.sections = data.section ? [data.section] : []
            }
            this.model = data
          }
          this.$nextTick(() => {
            this.loading = false
          })
        })
      },
      getSections () {
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/sections', 'GET', data, (response) => {
          if (response.status === true) {
            this.sectionOptions = response.data
          }
          this.$nextTick(() => {
            this.loading = false
          })
        })
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) { this.updateOrCreateKds() }
        })
      },
      updateOrCreateKds () {
        let data = { ...this.model }
        data.company_id = this.$session.get('selectedCompany')
        data.token = this.$session.get('token')

        if (data.sections && data.sections.length) {
          data.sections = data.sections.map(section => ({ id: section.id }))
        } else {
          data.sections = []
        }

        let url = '/kds/'
        let httpMethod = ''

        if (this.id) {
          url += this.id
          httpMethod = 'PUT'
        } else {
          httpMethod = 'POST'
        }

        this.apiRequest(url, httpMethod, data, response => {
          if (response.status === true) {
            const entityId = this.id || (response.data && response.data.id) || null
            this.trackAdminEvent('ADMIN_KDS_UPDATE', 'kds', entityId, {
              kds_id: entityId,
              name: data.name || null,
              request: data,
              response: response
            })
            swal(
              '',
              'Success',
              'success'
            )
            this.backButton()
          }
        })
      },
      handleErrors (errors) {
        for (var prop in errors) {
          if (errors.hasOwnProperty(prop)) {
            if (errors[prop].length === 1) {
              this.errors.add(prop, errors[prop][0])
            } else {
              this.errors.add(prop, errors[prop])
            }
          } else {
            this.errors.add('error', errors[prop])
          }
        }
      },
      limitToOne (val) {
        // pastreaza doar ultimul selectat
        if (this.model.is_offline && Array.isArray(this.model.locations) && this.model.locations.length > 1) {
          console.log('REMOVE')
          this.model.locations = [this.model.locations[this.model.locations.length - 1]]
        }
      },
      handleDelete () {
        this.$nextTick(() => { this.loading = true })
        var data = {
          company_id: this.$session.get('selectedCompany'),
          token: this.$session.get('token'),
          delete: true
        }
        this.apiRequest('/kds/' + this.id, 'DELETE', data, (response) => {
          if (response.status) {
            this.trackAdminEvent('ADMIN_KDS_DELETED', 'kds', this.id, {
              kds_id: this.id,
              name: (this.model && this.model.name) || null
            })
            this.$nextTick(() => { this.loadingReset = false })
            swal({'text': 'Success', 'type': 'success', 'showConfirmButton': false, 'timer': 2000})
            .then(() => {})
            .catch(() => {})
            this.backButton()
          } else {
            this.$nextTick(() => { this.loadingReset = false })
            swal({'text': this.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000})
            .then(() => {})
            .catch(() => {})
          }
        })
      },
      backButton () {
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
        // this.router.push('/screens/kds?tabIndex=0')
      }
    }
  }
</script>
<style scoped>
  .delivery_method_points{
    display: flex;
    align-items: center;
    gap: 30px;
  }

  .delivery_method_points :first-child {
    width: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Screens/Kds/KdsForm.vue